import {
  GET_VENDOR_PROFILE_REQUEST,
  GET_VENDOR_PROFILE_SUCCESS,
  GET_VENDOR_PROFILE_FAILURE,
  UPDATE_VENDOR_PROFILE_SUCCESS,
  UPDATE_VENDOR_PROFILE_REQUEST,
  UPDATE_VENDOR_PROFILE_FAILURE
} from "./ActionType";


const initialState = {
  loading: false,
  vendor: null,
  error: "",
}


const VendorReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDOR_PROFILE_REQUEST:
      return { ...state, loading: true };

    case GET_VENDOR_PROFILE_SUCCESS:
      return { ...state, loading: false, vendor: action.payload, error: "" };

    case GET_VENDOR_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_VENDOR_PROFILE_REQUEST:
      return { ...state, loading: true };

    case UPDATE_VENDOR_PROFILE_SUCCESS:
      return { ...state, loading: false, vendor: action.payload, error: "" };

    case UPDATE_VENDOR_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
export default VendorReducer